/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
/** The metadata returned by the Vimeo API for a video. */
type VimeoMetadata = {
  id: number
  title: string
  description: string
  url: string
  upload_date: string
  thumbnail_small: string
  thumbnail_medium: string
  thumbnail_large: string
  user_id: number
  user_name: string
  user_url: string
  user_portrait_small: string
  user_portrait_medium: string
  user_portrait_large: string
  user_portrait_huge: string
  stats_number_of_likes: number
  stats_number_of_plays: number
  stats_number_of_comments: number
  duration: number
  width: number
  height: number
  tags: string
  embed_privacy: string
}

/**
 * Fetches the metadata for a Vimeo video ID.
 *
 * @param videoId - the ID of the Vimeo video
 */
const fetchVimeoMetadata = async (videoId: string): Promise<VimeoMetadata> => {
  const response = await fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
  const data = await response.json()
  return data[0]
}

export { fetchVimeoMetadata }
export type { VimeoMetadata }
